<template>
    <div class="cable-configurator cable-configurator--nominal">
        <div class="cable-configurator__wrapper">
            <VoltageRiseValidation :is-valid="valid" />
            <div class="cable-configurator__items-wrapper">
                <span class="dropdown dropdown--source dropdown--icon-circle-chevron">
                    <v-select
                        placeholder="Select"
                        :clearable="false"
                        :searchable="false"
                        :value="value"
                        :options="options"
                        :reduce="label => label.value"
                        @input="update($event)"
                    />
                </span>
                <Tooltip text="If unsure contact your state or territory electrical regulator or the network you are connecting to. " />
            </div>
        </div>
    </div>
</template>
<script>
import Tooltip from '@/components/Tooltip';
import VoltageRiseValidation from '@/jobs/calculators/voltage-rise/VoltageRiseValidation';

export default {
    components: {
        VoltageRiseValidation,
        Tooltip
    },
    props: {
        value: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            options: [
                {
                    label: '230v',
                    value: 230,
                },
                {
                    label: '240v',
                    value: 240,
                },
            ],
            valid: false,
        };
    },
    created() {
        if (this.value) {
            this.valid = true;
        }
    },
    methods: {
        update(value) {
            this.$emit('update', value);
            this.valid = true;
        }
    },
};
</script>
